<button
	class="button"
	[class.loading]="isLoading()"
	[ngStyle]="{ 'justify-content': spreadContent() }"
	tuiButton
	[attr.data-shape]="shape()"
	[appearance]="appearance()"
	[size]="size()"
	[type]="type()"
	[disabled]="isDisabled()"
	(click)="click($event)"
>
	@if (!isLoading()) {
		@if (iconStart()) {
			<tui-icon
				class="icon"
				[icon]="'@tui.' + iconStart()"
				[style.height]="iconSize() || null"
			></tui-icon>
		}

		<ng-content></ng-content>

		@if (iconEnd()) {
			<tui-icon
				class="icon-color"
				[icon]="'@tui.' + iconEnd()"
				[style.height]="iconSize() || null"
			></tui-icon>
		}
	} @else {
		<span class="loader">
			<tui-icon
				class="icon"
				icon="loader-circle"
			/>
		</span>
	}
</button>
